/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('extras.wastetreatment', function (el) {
        var wasteTreatmentConfig = {
            nav: el.querySelectorAll('.wasteTreatment__nav .wasteTreatment__nav__category'),
            categories: el.querySelectorAll('.wasteTreatment__category'),
            currentCategory: el.querySelector('.wasteTreatment__category.active'),
            map: el.querySelector('.wasteTreatment__map svg'),
            wrap: el.querySelector('.wasteTreatment__wrap'),
        };
        WasteTreatment.create(wasteTreatmentConfig);
    });
    var WasteTreatment = /** @class */ (function () {
        function WasteTreatment(config) {
            this.nav = config.nav;
            this.categories = config.categories;
            this.map = config.map;
            this.currentCategory = config.currentCategory;
            this.wasteWrap = config.wrap;
        }
        WasteTreatment.create = function (config) {
            return new WasteTreatment(config).run();
        };
        WasteTreatment.prototype.run = function () {
            var _this = this;
            this.setMaxHeight(this.currentCategory);
            this.setActiveMapCirlce(this.getActiveCategory());
            this.bindNav();
            this.bindMap();
            window.addEventListener('resize', function () {
                _this.setMaxHeight(_this.currentCategory);
            });
        };
        WasteTreatment.prototype.bindNav = function () {
            var _this = this;
            this.nav.forEach(function (button) {
                util.delegate(button, 'click', '.wasteTreatment__nav__category', function (e) {
                    e.preventDefault();
                    if (!button.classList.contains('active')) {
                        _this.toggleCategory(button.getAttribute('data-category'));
                    }
                });
            });
        };
        WasteTreatment.prototype.setCategoryActive = function (category) {
            var _this = this;
            this.categories.forEach(function (cat) {
                if (cat.getAttribute('data-category') === category) {
                    cat.classList.add('active');
                    _this.currentCategory = cat;
                }
                else {
                    cat.classList.remove('active');
                }
            });
        };
        WasteTreatment.prototype.toggleButtons = function (category) {
            this.nav.forEach(function (button) {
                if (button.getAttribute('data-category') === category) {
                    button.classList.add('active');
                }
                else {
                    button.classList.remove('active');
                }
            });
        };
        WasteTreatment.prototype.setActiveMapCirlce = function (activeCategory) {
            Array.from(this.map.querySelectorAll('[data-category]')).forEach(function (elm) {
                if (elm.getAttribute('data-category') === activeCategory) {
                    elm.classList.add('active');
                }
                else {
                    elm.classList.remove('active');
                }
            });
        };
        WasteTreatment.prototype.getActiveCategory = function () {
            var ret = '';
            this.nav.forEach(function (el) {
                if (el.classList.contains('active')) {
                    ret = el.getAttribute('data-category');
                }
            });
            return ret;
        };
        WasteTreatment.prototype.toggleCategory = function (category) {
            var _this = this;
            this.currentCategory.classList.add('fade-out');
            setTimeout(function () {
                _this.currentCategory.classList.remove('fade-out');
                _this.currentCategory.classList.add('fade-in');
            }, 401);
            setTimeout(function () {
                _this.toggleButtons(category);
                _this.setCategoryActive(category);
                _this.setMaxHeight(_this.currentCategory);
                _this.setActiveMapCirlce(category);
            }, 401);
            this.currentCategory.classList.remove('fade-in');
        };
        WasteTreatment.prototype.bindMap = function () {
            var _this = this;
            Array.from(this.map.querySelectorAll('[data-category]')).forEach(function (elm) {
                util.delegate(elm, 'click', 'circle, path', function (e) {
                    e.preventDefault();
                    if (!elm.classList.contains('active')) {
                        _this.toggleCategory(elm.getAttribute('data-category'));
                    }
                });
            });
        };
        WasteTreatment.prototype.setMaxHeight = function (currentCategory) {
            if (window.innerWidth > 480) {
                this.wasteWrap.style.maxHeight = 70 + currentCategory.scrollHeight + 'px';
                this.wasteWrap.style.height = 70 + currentCategory.scrollHeight + 'px';
            }
            else {
                this.wasteWrap.style.maxHeight = null;
                this.wasteWrap.style.height = null;
            }
        };
        return WasteTreatment;
    }());

    exports.WasteTreatment = WasteTreatment;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
